<template>
  <div>
    <b-checkbox
        v-model="firstCheckBox"
    >{{ $t(firstCheckBoxTitle) }}
    </b-checkbox>
    <b-checkbox
        v-model="secondCheckBox"
    >{{ $t(secondCheckBoxTitle) }}
    </b-checkbox>
  </div>
</template>

<script>
export default {
  name: 'YesNoSelectors',
  props: ['value', 'options'],
  data()
  {
    return {
      firstCheckBox: this.options[0]?.value,
      firstCheckBoxTitle: this.options[0]?.name_i18n ? this.options[0]?.name_i18n : this.options[0]?.name,
      secondCheckBox: this.options[1]?.value,
      secondCheckBoxTitle: this.options[1]?.name_i18n ? this.options[1]?.name_i18n : this.options[1]?.name
    }
  },
  mounted()
  {
     this.setPredefinedValue(this.value)
  },
  watch: {
    value(val)
    {
      this.setPredefinedValue(val)
    },
    firstCheckBox(val)
    {
      this.setCheckBox(val, 1)
    },
    secondCheckBox(val)
    {
      this.setCheckBox(val, 2)
    }
  },
  methods: {
    setCheckBox(val, number)
    {
      const values = []
      switch (number)
      {
        case 1:
          if (val)
          {
            values.push(this.options[0]?.value)
          }
          if (this.secondCheckBox === true) {
            values.push(this.options[1]?.value)
          }
          break
        case 2:
          if (val)
          {
            values.push(this.options[1]?.value)
          }
          if (this.firstCheckBox === true) {
            values.push(this.options[0]?.value)
          }
          break
      }
      this.$emit('updatevalues', values)
    },
    setPredefinedValue(val)
    {
      if (!val || (val && !val.length))
      {
        this.firstCheckBox = false
        this.secondCheckBox = false
      } else
      {
        val.forEach((item) => {
              if (typeof item === 'string') {
                if (this.options[0]?.value === item) {
                  this.firstCheckBox = true
                }
                if (this.options[1]?.value === item) {
                  this.secondCheckBox = true
                }
              } else {
                this.firstCheckBox = false
                this.secondCheckBox = false
              }
            }
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
